module.exports = require("npm:a11y-toggle@2.1.0/a11y-toggle.js");